<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { CardPlanVariant } from '@sunlabde/m2m-library';
import type { PlanVariant, PriceComparison } from '@/models/PlanVariant';
import type { Discount } from '@/models/Discounts';
import { useProductsStore } from '@/store/products';
import type { Product } from '@/models/Product';
import type { BillingOccurence } from '@/models/BillingOccurence';

const props = withDefaults(defineProps<{
	planVariant: PlanVariant;
	discount?: Discount | null;
}>(), {
	discount: null,
});

const emit = defineEmits<{
	(e: 'click', event: MouseEvent): void;
}>();

const onClick = (event: MouseEvent) => {
	emit('click', event);
};

const productsStore = useProductsStore();
const { allowsTrialOrder } = storeToRefs(productsStore);

const portalCategoryProducts = computed((): Product[] => productsStore.getProductsFromCategory(props.planVariant.CustomFields.category));
const comboComparisonByBillingOccurence = computed((): Record<BillingOccurence, PriceComparison> => productsStore.comboComparisonByBillingOccurence);
</script>

<template>
	<CardPlanVariant
		:plan-variant="planVariant"
		:discount="discount"
		:portal-category-products="portalCategoryProducts"
		:combo-comparison-by-billing-occurence="comboComparisonByBillingOccurence"
		:allows-trial-order="allowsTrialOrder"
		@click="onClick"
	/>
</template>
